
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assignments",
      function () {
        return require("private-next-pages/assignments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assignments"])
      });
    }
  